import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Getpermission,
  Updatepermission,
} from "../../../store/permission-store/permission-actions";
import PermissionForms from "../../../components/Forms/PermissionForms";
import { getTokenInfo } from "../../../utils/Guard";

const PermissionEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const permission = useSelector((state) => state.permission.permission);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (permission.id===undefined || permission.id === 0) {
      dispatch(Getpermission(param.permissionId, userInfo.Email));
    }
  }, [param.permissionId, dispatch, permission]);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <PermissionForms actionpermission={Updatepermission} permission={permission} />
    </div>
    </>
  );
};
export default PermissionEdit;
